module.exports = __webpack_public_path__ + "img/b0fdcf5.jpg";